"use client";

import React from "react";
import { Share } from "@phosphor-icons/react";
import { RWebShare as ReactWebShare } from "react-web-share";

interface ShareButtonProps {
  title: string;
  description: string;
  url: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ title, description, url }) => {
  return (
    <ReactWebShare
      data={{
        title,
        text: description,
        url,
      }}
      onClick={() => console.log("Shared successfully!")}
    >
      <button className="flex items-center text-secondary">
        <Share className="w-4 h-4 mr-1" /> Share
      </button>
    </ReactWebShare>
  );
};

export default ShareButton;